var APPID = "bea61041";
var API_KEY = "2de3bbf842ab225ac7a061a066150874";
let btnStatus = "UNDEFINED"; // "UNDEFINED" "CONNECTING" "OPEN" "CLOSING" "CLOSED"
let iatWS;
let resultText = "";
let resultTextTemp = "";
let countdownInterval;
let inx = -1
let cb1, cb2
export const recorder = new RecorderManager("/example/dist");
export function changeBtnStatus(status) {
  btnStatus = status;
  if (status === "CONNECTING") {
    // btnControl.innerText = "建立连接中";
    cb2(inx, '建立连接中')
    resultText = "";
    resultTextTemp = "";
  } else if (status === "OPEN") {
    cb1(true)
    // btnControl.innerText = "录音中";
    cb2(inx, '录音中')
  } else if (status === "CLOSING") {
    cb1(false)
    // btnControl.innerText = "关闭连接中";

  } else if (status === "CLOSED") {
    // btnControl.innerText = "开始录音";
  }
}
export function getWebSocketUrl() {
  // 请求地址根据语种不同变化
  var url = "wss://rtasr.xfyun.cn/v1/ws";
  var appId = APPID;
  var secretKey = API_KEY;
  var ts = Math.floor(new Date().getTime() / 1000);
  var signa = hex_md5(appId + ts);
  var signatureSha = CryptoJSNew.HmacSHA1(signa, secretKey);
  var signature = CryptoJS.enc.Base64.stringify(signatureSha);
  signature = encodeURIComponent(signature);
  return `${url}?appid=${appId}&ts=${ts}&signa=${signature}`;
}
export function renderResult(resultData) {
  let jsonData = JSON.parse(resultData);
  if (jsonData.action == "started") {
    // 握手成功
    console.log("握手成功");
  } else if (jsonData.action == "result") {
    const data = JSON.parse(jsonData.data)
    console.log(data)
    // 转写结果
    let resultTextTemp = ""
    data.cn.st.rt.forEach((j) => {
      j.ws.forEach((k) => {
        k.cw.forEach((l) => {
          resultTextTemp += l.w;
        });
      });
    });
    if (data.cn.st.type == 0) {
      // 【最终】识别结果：
      resultText = resultText + resultTextTemp;
      // console.log('resultText', resultText);
      if (resultTextTemp) {
        cb2 && cb2(inx, resultText)
      } else {
        cb2 && cb2(inx, '')
      }
      // inx = -1
      // resultTextTemp = ""
      // resultText = ""
    }
  } else if (jsonData.action == "error") {
    // 连接发生错误
    console.log("出错了:", jsonData);
  }
}
/**
 * 获取websocket url
 * 该接口需要后端提供，这里为了方便前端处理
 */
export function connectWebSocket(index) {
  inx = index
  const websocketUrl = getWebSocketUrl();
  if ("WebSocket" in window) {
    iatWS = new WebSocket(websocketUrl);
  } else if ("MozWebSocket" in window) {
    iatWS = new MozWebSocket(websocketUrl);
  } else {
    alert("浏览器不支持WebSocket");
    return;
  }
  changeBtnStatus("CONNECTING");
  iatWS.onopen = (e) => {
    // 开始录音
    recorder.start({
      sampleRate: 16000,
      frameSize: 1280,
    });
  };
  iatWS.onmessage = (e) => {
    renderResult(e.data);
  };
  iatWS.onerror = (e) => {
    console.error(e);
    recorder.stop();
    changeBtnStatus("CLOSED");
  };
  iatWS.onclose = (e) => {
    recorder.stop();
    changeBtnStatus("CLOSED");
  };
}
export const initVoice = (cb3, cb4) => {
  cb1 = cb3
  cb2 = cb4
  recorder.onStart = () => {
    changeBtnStatus("OPEN");
  }

  recorder.onFrameRecorded = ({ isLastFrame, frameBuffer }) => {
    if (iatWS.readyState === iatWS.OPEN) {
      iatWS.send(new Int8Array(frameBuffer));
      if (isLastFrame) {
        iatWS.send('{"end": true}');
        changeBtnStatus("CLOSING");
      }
    }
  };
  recorder.onStop = () => {
    clearInterval(countdownInterval);
  };
}
